module.exports = __webpack_public_path__ + "img/noData.f73d5692.png";